import { LanguageType } from 'types/enums';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveyCompletedPage = () => {
	const { language } = useSurveyContext();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 items-center sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">
						{dictionary.surveyCompleted}
					</h1>
					<p className="text-sm sm:text-lg">{dictionary.thankYou}</p>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		surveyCompleted: 'Survey already completed',
		thankYou: 'Thank you for your participation'
	},
	[LanguageType.Norwegian]: {
		surveyCompleted: 'Undersøkelse allerede fullført',
		thankYou: 'Takk for din deltakelse'
	}
};
